import http from '@/support/plugin/axios'

export const

updatePasswordByRecoverUniqueId = ( newPassword, recoverUniqueId  ) => {
    const body = {
        newPassword: newPassword
    }
    
    return http.patch(`users/password?recoverUniqueId=${recoverUniqueId }`, body)
}